export const ModalCloseIcon = () => (
  <svg width='50' height='50' viewBox='0 0 50 50' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <circle cx='25' cy='25' r='25' fill='#454A54' />
    <path d='M30.9854 19L19.5001 30.4853' stroke='white' strokeWidth='1.6' strokeLinejoin='round' />
    <path d='M30.9854 30.4854L19.5001 19.0001' stroke='white' strokeWidth='1.6' strokeLinejoin='round' />
  </svg>
)
